/**
 * Eine Versions-Wahrheit.
 * Web-Nummer = package.json (via __BUILD_VERSION__, ohne Zeitstempel).
 * Native-Build nie als zweite Web-Nummer — nur als „App“, klar getrennt.
 */

export function webVersionAus(raw: string | undefined | null): string {
  const s = String(raw ?? "").trim();
  const m = /^(\d+\.\d+\.\d+(?:-[a-z]+\.\d+)?)/.exec(s);
  return m?.[1] ?? "";
}

export function sichtbareVersion(
  web: string,
  nativeBuild?: string | null,
): string {
  const w = web.trim();
  const n = String(nativeBuild ?? "").trim();
  if (w && n) return `Web ${w} · App ${n}`;
  return w;
}

let _web = "";
let _native: string | null = null;

export function setzeVersionsQuellen(
  webRaw: string | undefined | null,
  nativeBuild?: string | null,
): void {
  _web = webVersionAus(webRaw);
  const n = String(nativeBuild ?? "").trim();
  _native = n || null;
}

export function sichtbareVersionJetzt(): string {
  return sichtbareVersion(_web, _native);
}

export function laufendeWebVersion(): string {
  return _web;
}
